<template>
    <nav class="navbar navbar-expand-lg navbar-light fixed-top py-3 d-block" data-navbar-on-scroll="data-navbar-on-scroll">
        <div class="container"><a class="navbar-brand" href="/"><img src="../assets/img/gallery/logo.png" height="45" alt="logo" /></a>
          <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation"><span class="navbar-toggler-icon"> </span></button>
          <div class="collapse navbar-collapse border-top border-lg-0 mt-4 mt-lg-0" id="navbarSupportedContent">
            <ul class="navbar-nav ms-auto pt-2 pt-lg-0">
              <li class="nav-item px-2"><a class="nav-link" href="#top">Beranda</a></li>
              <!-- li class="nav-item px-2"><router-link class="nav-link" to="/about">About</router-link></li -->
              <li class="nav-item px-2"><a class="nav-link" href="#feature">Fitur</a></li>
              <li class="nav-item px-2"><a class="nav-link" href="#services">Layanan</a></li>
              <li class="nav-item px-2"><a class="nav-link" href="#faq">FAQ</a></li>
              <li class="nav-item px-2"><a class="nav-link" href="#contact">Hubungi Kami</a></li>
            </ul>
            <!-- div class="dropdown d-none d-lg-block">
              <button class="btn bg-soft-warning ms-2" id="dropdownMenuButton1" type="submit" data-bs-toggle="dropdown" aria-expanded="false"><i class="fas fa-search text-warning"></i></button>
              <div class="dropdown-menu dropdown-menu-lg-end p-0 rounded" aria-labelledby="dropdownMenuButton1" style="top:55px">
                <form>
                  <input class="form-control border-200" type="search" placeholder="Search" aria-label="Search" style="background:#FDF1DF;" />
                </form>
              </div>
            </div --><a v-bind:href="url_service" class="btn btn-primary order-1 fw-bold order-lg-0 ms-lg-3">Login</a>
            <form class="d-flex my-3 d-block d-lg-none">
              <input class="form-control me-2 border-200 bg-light" type="search" placeholder="Search" aria-label="Search" />
              <button class="btn btn-outline-primary" type="submit">Search</button>
            </form>
          </div>
        </div>
      </nav>
</template>

<script>
export default {
    name : 'Navbar',
    data(){
      return {
        url_service : process.env.VUE_APP_URL_SERVICE+'/login'
      }
    }
}
</script>

<style>

</style>